

import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";
import AppCrmHistoryEvent from "./CrmHistoryEvent.vue";
import AppCrmEditHistoryEvent from "./CrmEditHistoryEvent.vue";
import { ISelectItem } from "winfakt-vue-components";
import { Contact } from "@/models/base";
import Crm from "@/models/crm/crm";
import {CrmEditState} from "@/utils/crm/crm-edit-state";
import { UserConfigService } from "@/services";

export default Vue.extend({
	data() {
		return {
			historyEvent: new CrmHistory(),
			editHistoryEvent: false,
			selectedFilters: [1, 2, 3, 4, 5, 6, 7, 8] as number[],
			filterMenuOpen: false,
			filtersInitialized: false,
		};
	},
	props: {
		crm: {
			required: true,
			type: Object as () => Crm
		},
		history: {
			required: true,
			type: Array as () => CrmHistory[]
		},
		contact: {
			required: true,
			type: Object as () => Contact,
		},
		action: {
			required: false,
			type: Object as () => CrmHistory,
		},
		state: {
			required: true,
			type: Object as () => CrmEditState
		}
	},
	computed: {
		actionList(): ISelectItem<string>[] {
			let data = [
				{text: this.$ct("actions.message").toString(), value: "1", icon: "info"},
				{text: this.$ct("actions.call").toString(), value: "2", icon: "phone"},
				/*{text: this.$ct("actions.email").toString(), value: "3", icon: "envelope"},*/
				{text: this.$ct("actions.appointment").toString(), value: "4", icon: "calendar-check"},
				{text: this.$ct("actions.file").toString(), value: "8", icon: "paperclip"},
				{text: this.$ct("actions.sale").toString(), value: "6", icon: "money-check-alt"},
				{text: this.$ct("actions.offer").toString(), value: "7", icon: "shopping-bag"},
				{text: this.$ct("actions.close").toString(), value: "5", icon: "power-off"},
			];
			return data;
		},
		filterList(): {text: string, value: number}[] {
			return [
				{text: this.$ct("actions.message").toString(), value: 1},
				{text: this.$ct("actions.call").toString(), value: 2},
				{text: this.$ct("actions.appointment").toString(), value: 4},
				{text: this.$ct("actions.file").toString(), value: 8},
				{text: this.$ct("actions.close").toString(), value: 5},
				{text: this.$ct("actions.sale").toString(), value: 6},
				{text: this.$ct("actions.offer").toString(), value: 7},
			];
		},
		filteredHistory(): CrmHistory[] {
			if (this.selectedFilters.length === 0) {
				return this.history;
			}
			return this.history.filter(event => this.selectedFilters.includes(event.EventTypeID));
		},
	},
	watch: {
		"action"(){
			if(this.action){
				this.historyEvent = this.action;
				this.editHistoryEvent = true;
			}
		},
		selectedFilters: {
			handler(newVal: number[]) {
				if (!this.filtersInitialized) return;
				const settings = UserConfigService.getCrmSettings();
				settings.HistoryFilterEventTypeIDs = newVal;
				UserConfigService.setCrmSettings(settings);
			},
			deep: true
		}
	},
	methods: {
		isFilterSelected(value: number): boolean {
			return this.selectedFilters.includes(value);
		},
		toggleFilter(value: number, selected: boolean) {
			if (selected) {
				if (!this.selectedFilters.includes(value)) {
					this.selectedFilters.push(value);
				}
			} else {
				const index = this.selectedFilters.indexOf(value);
				if (index > -1) {
					this.selectedFilters.splice(index, 1);
				}
			}
		},
		selectAllFilters() {
			this.selectedFilters = [1, 2, 3, 4, 5, 6, 7, 8];
		},
		deselectAllFilters() {
			this.selectedFilters = [];
		},
		triggerAction(value: string) {
			if(value=="6"){
				this.$router.push("/sales/new?typeId=1&contactId="+this.contact.ID+"&crmId="+this.crm.ID);
				return;
			}
			if(value=="7"){
				this.$router.push("/sales/new?typeId=3&contactId="+this.contact.ID+"&crmId="+this.crm.ID);
				return;
			}
			this.historyEvent.EventTypeID = parseInt(value);
			this.editHistoryEvent = true;
			this.$emit("input", value);
		},
		cancel(){
			this.editHistoryEvent = false;
			this.historyEvent = new CrmHistory();
		},
		async saveHistory(value:CrmHistory){
			this.$emit("save",value);
			this.historyEvent = new CrmHistory();
			this.editHistoryEvent = false;
		},
		async updateHistory(value:CrmHistory){
			this.$emit("update",value);
			this.historyEvent = new CrmHistory();
			this.editHistoryEvent = false;
		},
		edit(event:CrmHistory){
			this.editHistoryEvent = true;
			this.historyEvent = event;
		}
	},
	mounted() {
		const settings = UserConfigService.getCrmSettings();
		this.selectedFilters = settings.HistoryFilterEventTypeIDs;
		this.$nextTick(() => {
			this.filtersInitialized = true;
		});
	},
	components: {
		AppCrmHistoryEvent,
		AppCrmEditHistoryEvent
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
